/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.10.14",
    versionName: "0.2.0-nightly.2025.10.14",
    versionChannel: "nightly",
    buildDate: "2025-10-14T00:07:37.271Z",
    commitHash: "3a9511ad80d00e2562e4bd2e2cfe9158069b6d5e",
};
